export default __webpack_public_path__ + "static/media/pfbDental.2e9cfac9.jpg";